// @flow

import type { Node } from 'react';

type TProps = {
  setPopupContent: (N: Node) => void
};

export const Header = 'Shape';

export function Content({ setPopupContent }: TProps) {
  return (
    <div>
      <p>
        Refers to the shape of all diamonds within a particular accent group.
      </p>
    </div>
  );
}
